import { useMemo } from 'react';
import { useAllSellerFulfillmentProviders } from './use-seller-fulfillment-providers';
import { EXTERNAL_SHIP_FROM_PREFIX } from '../store/csw/csw.fulfillment-plan-to-csw';

const removeInactiveProviders = (provider) => provider.isActive;

export const useSellerFulfillmentProvider = (sellerFulfillmentProviderId, shouldQueryInactiveProviders = false) => {
  const allSellerFulfillmentProviders = useAllSellerFulfillmentProviders();
  const sellerFulfillmentProvidersToQuery = shouldQueryInactiveProviders
    ? allSellerFulfillmentProviders
    : allSellerFulfillmentProviders.filter(removeInactiveProviders);

  return useMemo(() => {
    return sellerFulfillmentProvidersToQuery.find((sellerFulfillmentProvider) => {
      return sellerFulfillmentProvider.sellerFulfillmentProviderId === sellerFulfillmentProviderId;
    });
  }, [sellerFulfillmentProvidersToQuery, sellerFulfillmentProviderId]);
};

export const useSellerFulfillmentProviderByExternalShipFromId = (externalShipFromId) => {
  const allSellerFulfillmentProviders = useAllSellerFulfillmentProviders();

  const [, sellerFulfillmentProviderId] = externalShipFromId?.split(EXTERNAL_SHIP_FROM_PREFIX) || [];

  return useMemo(() => {
    return allSellerFulfillmentProviders.find((sfp) => sfp.sellerFulfillmentProviderId === sellerFulfillmentProviderId);
  }, [allSellerFulfillmentProviders, sellerFulfillmentProviderId]);
};
